"use strict";

const iconWebUtils = {
  renderWebGradientDefs: (gradient, gradientId) => {
    if (!gradient || !gradientId) return null;
    const React = require('react');
    if (gradient.type === 'linear') {
      const angle = 180 - (gradient.angle || 0);
      return React.createElement('defs', null, React.createElement('linearGradient', {
        id: gradientId,
        gradientTransform: `rotate(${angle})`
      }, gradient.stops.map((stop, index) => {
        const offset = stop.hint !== undefined ? stop.hint * 100 : stop.stop !== undefined ? stop.stop * 100 : '';
        return React.createElement('stop', {
          key: index,
          offset: `${offset}%`,
          stopColor: stop.color
        });
      })));
    } else if (gradient.type === 'radial') {
      let cx = '50%',
        cy = '50%',
        r = '50%';
      if (typeof gradient.specification === 'string' && gradient.specification.length < 1000) {
        const match = gradient.specification.match(/^(\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)%\s+at\s+(\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)%$/);
        if (match) {
          r = match[1] + '%';
          cx = match[3] + '%';
          cy = match[4] + '%';
        }
      }
      return React.createElement('defs', null, React.createElement('radialGradient', {
        id: gradientId,
        cx: cx,
        cy: cy,
        r: r,
        gradientUnits: "userSpaceOnUse"
      }, gradient.stops.map((stop, index) => {
        const offset = stop.hint !== undefined ? stop.hint * 100 : stop.stop !== undefined ? stop.stop * 100 : '';
        return React.createElement('stop', {
          key: index,
          offset: `${offset}%`,
          stopColor: stop.color
        });
      })));
    }
    return null;
  }
};
module.exports = iconWebUtils;